import React from 'react'
import PropTypes from 'prop-types'
import { motion } from 'motion/react'

const pathEase = { ease: 'easeOut', duration: 0.15 }

const MotionPath = motion.path

export const FatTick = React.forwardRef(
  (
    { size = '28', color = 'currentColor', checked, strokeWidth = 3, ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 49.5 39.18"
      width={size}
      height={size}
      ref={ref}
      {...props}
    >
      <defs>
        <clipPath id="tickClip">
          <path
            d="M45.34,3.78a5.43,5.43,0,0,0-7.4.4L18.48,23.65a.47.47,0,0,1-.66,0l-6.17-6.18a5.44,5.44,0,0,0-7.4-.4,5.22,5.22,0,0,0-.2,7.58l6.71,6.71,5,5a3.39,3.39,0,0,0,4.8,0l5-5,20-20A5.22,5.22,0,0,0,45.34,3.78Z"
            fill="white"
          />
        </clipPath>
      </defs>

      <MotionPath
        initial={
          checked
            ? { pathLength: 0, opacity: 0 }
            : { pathLength: 1, opacity: 1 }
        }
        animate={
          checked
            ? {
                pathLength: 0,
                opacity: 0,
                transition: { pathLength: pathEase },
              }
            : {
                pathLength: 1,
                opacity: 1,
                transition: { pathLength: pathEase },
              }
        }
        d="M45.5,4L22.1,27.3c-2.2,2.2-5.8,2.2-8,0L4.1,17.3"
        stroke={color}
        strokeLinecap="rounded"
        strokeWidth="18"
        clipPath="url(#tickClip)"
        style={{ WebkitClipPath: 'url(#tickClip)' }}
        fill="none"
      />

      <path
        d="M45.34,3.78a5.43,5.43,0,0,0-7.4.4L18.48,23.65a.47.47,0,0,1-.66,0l-6.17-6.18a5.44,5.44,0,0,0-7.4-.4,5.22,5.22,0,0,0-.2,7.58l6.71,6.71,5,5a3.39,3.39,0,0,0,4.8,0l5-5,20-20A5.22,5.22,0,0,0,45.34,3.78Z"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        clipPath="url(#tickClip)"
        style={{ WebkitClipPath: 'url(#tickClip)' }}
      />
    </svg>
  ),
)

FatTick.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
}
